import React, { PureComponent } from 'react'
import cn from 'classnames'
import Popover from "react-popover"
import Icon from 'components/common/elements/Icon'
import ActionPopover from './ActionPopover'

class Action extends PureComponent {
  constructor() {
    super();
    this.state = {
      popoverIsOpen: false,
      preferPlace: 'right',
      place: null
    };
  }
  togglePopover (toState) {
    const popoverIsOpen = typeof toState === "boolean"
      ? toState
      : !this.state.popoverIsOpen
    this.setState({
      popoverIsOpen
    })
  }

  render () {
    const popoverProps = {
      isOpen: this.state.popoverIsOpen,
      preferPlace: this.state.preferPlace,
      place: this.state.place,
      tipSize: 0.01,
     // onOuterAction: () => this.togglePopover(false),
      body: <ActionPopover onHide={() => this.setState({popoverIsOpen:false}) } />
    }
    const { isMenuOpen } = this.props;
    return (
      <Popover {...popoverProps}>
        <div className={cn('MenuIcon', {onlyIcon: !isMenuOpen})}
             onClick={(e) => this.togglePopover(e)}>
          <Icon icon="plus" size={46} role="button"/>
          <span className="gs-text" role="button">Import / Export</span>
        </div>
      </Popover>
    )
  }
}

export default Action
